import { organizationSelector } from '../selectors/Organization';

export const types = {
  GET_BILLING_INFO_REQUEST: 'BILLING/GET_BILLING_INFO_REQUEST',
  GET_BILLING_INFO_SUCCESS: 'BILLING/GET_BILLING_INFO_SUCCESS',
  GET_BILLING_INFO_FAILURE: 'BILLING/GET_BILLING_INFO_FAILURE',
  UPDATE_INVOICE_CONTACT_REQUEST: 'BILLING/UPDATE_INVOICE_CONTACT_REQUEST',
  UPDATE_INVOICE_CONTACT_SUCCESS: 'BILLING/UPDATE_INVOICE_CONTACT_SUCCESS',
  UPDATE_INVOICE_CONTACT_FAILURE: 'BILLING/UPDATE_INVOICE_CONTACT_FAILURE',
};

export const initialState = {
  error: null,
  isLoading: false,
  isUpdating: false,
  byUUID: {},
};

export default (state = initialState, action) => {
  const { billing, uuid } = action;
  switch (action.type) {
    case types.GET_BILLING_INFO_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_BILLING_INFO_SUCCESS:
      return {
        ...state,
        isLoading: false,
        byUUID: {
          ...state.byUUID,
          [uuid]: billing,
        },
      };
    case types.GET_BILLING_INFO_FAILURE:
      return { ...state, isLoading: false, error: action.error };
    case types.UPDATE_INVOICE_CONTACT_REQUEST:
      return { ...state, isUpdating: true, error: null };
    case types.UPDATE_INVOICE_CONTACT_SUCCESS:
      return { ...state, isUpdating: false };
    case types.UPDATE_INVOICE_CONTACT_FAILURE:
      return { ...state, isUpdating: false, error: action.error };
    default:
      return state;
  }
};

export const actions = {
  fetchBillingInfo: (organizationUUID) => ({
    type: types.GET_BILLING_INFO_REQUEST,
    organizationUUID,
  }),
  updateInvoiceContactInfo: (organizationUUID, name, email, memo) => ({
    type: types.UPDATE_INVOICE_CONTACT_REQUEST,
    organizationUUID,
    name,
    email,
    memo,
  }),
};

export const selectors = {
  billingInfoByUUID: (state, uuid) => {
    return state.billing.byUUID[uuid];
  },
  isGithubPlan: (state, uuid) => {
    const billing = selectors.billingInfoByUUID(state, uuid);
    return billing?.products?.code_review?.billing?.provider === 'github';
  },
  isOptInBilling: (state, uuid) => {
    const billing = selectors.billingInfoByUUID(state, uuid);
    return billing?.products?.code_review?.billing?.is_opt_in_billing;
  },
  isStaticUsers: (state, uuid) => {
    const billing = selectors.billingInfoByUUID(state, uuid);
    return billing?.products?.code_review?.billing?.is_static_users;
  },
  hasStaticSeatsAssigned: (state, uuid) => {
    const billing = selectors.billingInfoByUUID(state, uuid);
    const isOptInBilling = selectors.isOptInBilling(state, uuid);
    const isStaticUsers = selectors.isStaticUsers(state, uuid);
    const totalSeats = selectors.getTotalSeats(state, uuid);
    const availableSeats = selectors.getAvailableSeats(state, uuid);

    return Boolean(
      billing &&
        isOptInBilling &&
        isStaticUsers &&
        totalSeats &&
        totalSeats !== availableSeats
    );
  },
  getAvailableSeats: (state, uuid) => {
    const totalSeats = selectors.getTotalSeats(state, uuid);
    const assignedSeats = selectors.getAssignedSeats(state, uuid);

    return Math.max(totalSeats - assignedSeats, 0);
  },
  getTotalSeats: (state, uuid) => {
    const billing = selectors.billingInfoByUUID(state, uuid);
    return billing?.products?.code_review?.billing?.quantity || 0;
  },
  getAssignedSeats: (state, uuid) => {
    const billing = selectors.billingInfoByUUID(state, uuid);
    return billing?.num_seats || 0;
  },
  shouldShowSubscriptionModal: (state, uuid) => {
    const organization = organizationSelector(state);
    const billing = selectors.billingInfoByUUID(state, uuid);
    const codeReview = billing?.products?.code_review;
    return Boolean(
      codeReview?.enabled &&
        codeReview?.billing?.plan === 'subscription' &&
        codeReview?.billing?.status === 'canceled' &&
        (billing?.card_last_four || organization?.has_invoice_billing)
    );
  },
  shouldShowTrialModal: (state, uuid) => {
    const billing = selectors.billingInfoByUUID(state, uuid);
    const codeReviewBilling = billing?.products?.code_review?.billing;
    return !codeReviewBilling && billing?.has_subscription_billing;
  },
  getUpgradeUrl: (state, uuid) => {
    const billing = selectors.billingInfoByUUID(state, uuid);
    return billing?.products?.code_review?.billing?.upgrade_url || '';
  },
};
